import React, { useCallback, useState } from 'react';
import PropTypes       from 'prop-types';
import classNames      from 'classnames';
import { CSSTransition } from 'react-transition-group';
import style           from '../WrapperCard/WrapperCard.module.scss';
import CardHighlighted from '../CardHighlighted';
import HeartCardIcon   from '../../assets/icon/HeartCardIcon';
import product         from '../../assets/images/product.jpg';
import InfoIcon        from '../../assets/icon/InfoIcon';
import Button          from '../Button';
import CartIcon        from '../../assets/icon/CartIcon';
import styleCard       from './Card.module.scss';

// eslint-disable-next-line no-unused-vars
function Card({ i, classTitle, link, extId, name, id, price, image, discounts, showcases, discountPrice, instructions }) {
    const [ animation, setAnimation ] = useState(false);

    const handleAnimation = useCallback(() => {
        setAnimation(true);

        setTimeout(() => {
            setAnimation(false);
        }, 1200);
    }, []);

    return (
        <div
            data-link={link ? link : `/product/${id ? id : 2593}`}
            className={classNames(style['card-wrapper'], '--border',  { [style.card]: classTitle })}
        >
            <CardHighlighted
                classTitle={classTitle}
                sale={!!discountPrice}
                recipe={!!instructions}
                news={i === 3}
            />
            <button className={style['card-wrapper__heart']}>
                <HeartCardIcon />
            </button>
            <img

                data-src={image ? image : product}
                height={'142'}
                className={'lazyload'}
                alt={'test'}
            />
            <h4>
                { name ? name : 'Test Name' }
            </h4>

            <span className={style['card-wrapper__info']}>
                { extId ? extId : 'Description' }
            </span>

            <div className={style['card-wrapper__count']}>
                <span>
                    { `В наявності в ${showcases[0]?.availability?.length} аптеках` }
                </span>

                <button>
                    <InfoIcon />
                </button>
            </div>

            <div className={style['card-wrapper__price']}>
                {
                    price?.discountPrice ?
                        <div>
                            <span>
                                {price?.discountPrice} грн
                            </span>
                            <span>
                                { price?.price ? `${price.price  } грн` : '100 грн' }
                            </span>
                        </div>

                        :

                        <span className={style['card-wrapper__total-price']}>
                            { price?.price ? `${price.price  } грн` : '100 грн' }
                        </span>

                }

                <Button
                    clsTitle={!id ? styleCard.disable : ''}
                    name={'У кошик'}
                    event={handleAnimation}
                    cart={{
                        ...(price?.discountPrice ? { price: price?.discountPrice } : { price: price?.price }),
                        productId : id,
                        image,
                        name,
                        // discounts,
                        quantity  : 1
                    }}
                >
                    {
                        <CSSTransition
                            timeout={300}
                            in={animation}
                            unmountOnExit
                            classNames='item'
                            mode={'out-in'}>
                            <p className={styleCard.add}>
                                Додано
                            </p>
                        </CSSTransition>
                    }
                    <CartIcon />
                </Button>
            </div>
        </div>
    );
}

Card.propTypes = {
    i             : PropTypes.number,
    classTitle    : PropTypes.string,
    link          : PropTypes.string,
    extId         : PropTypes.string,
    name          : PropTypes.string,
    id            : PropTypes.number,
    price         : PropTypes.object,
    image         : PropTypes.string,
    discounts     : PropTypes.array,
    showcases     : PropTypes.array,
    instructions  : PropTypes.string,
    discountPrice : PropTypes.number
};

Card.defaultProps = {
    i             : 0,
    classTitle    : '',
    link          : null,
    extId         : '',
    name          : '',
    id            : null,
    price         : {},
    image         : '',
    discounts     : [],
    showcases     : [],
    instructions  : '',
    discountPrice : null
};

export default React.memo(Card);
